import axiosInstance from "./axios"

export const materialLead = async (data) => {
  try {
    const response = await axiosInstance.post('/leads', {
      name: data.name, 
      email: data.email, 
      tel: data.whatsapp, 
      event: 'simulados-craques-enem-2026'
    })

    return response.data
  } catch (error) {
    console.error(error)
    return error
  }
}